import service from "@/store/services/event-kiosks-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  eventKiosk: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, eventKiosk) => {
    state.eventKiosk = eventKiosk;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((eventKiosk) => {
      commit("SET_RESOURCE", eventKiosk);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((eventKiosk) => {
      commit("SET_RESOURCE", eventKiosk);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((eventKiosk) => {
      commit("SET_RESOURCE", eventKiosk);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  eventKiosk: (state) => state.eventKiosk,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((eventKiosk) => ({
      id: eventKiosk.id,
      name: eventKiosk.full_kiosk_name,
    }));
  },
};

const eventKiosks = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default eventKiosks;
